// extracted by mini-css-extract-plugin
export default {"textWrapper":"errorText_textWrapper__L07sb","errorMessageText":"errorText_errorMessageText__3RS+2","title":"errorText_title__Upf+d","link":"errorText_link__Y8EzX"};